<script>
    import {onDestroy} from 'svelte';
    import R, {LOADER} from "../lib/requests";
    import samples from "../stores/samples";
    import {setFocusTo} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";
    import OrderSample from "../orders/OrderSample.svelte";
    import PdfModal from "../orders/PdfModal.svelte";
    import Notifier from "../stores/notifier";
    import Alert from "../stores/alerts";

    export let sampleId;

    let sample = null;
    let order = null;
    let client = null;
    let analysesGroups = [];
    let unloadEventInitialized = false;
    let printItems = null;
    let notFound = false;

    const breadcrumb = [
        {id: 'samples', name: 'Δείγματα', link: `/app/samples`}
    ];

    let pageHeaderControls = [
        {id: 'save', name: 'ΕΝΗΜΕΡΩΣΗ', tip: 'ενημέρωση δείγματος', class: 'hidden-xs'},
        {
            id: 'save',
            name: '',
            tip: 'ενημέρωση δείγματος',
            icon: 'save',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
    ];

    const beforeUnloadListener = (event) => {
        event.preventDefault();
        return (event.returnValue = "");
    };

    const load = () => {
        const onSuccess = result => {
            sample = result.sample;
            sample.is_collapsed = 0;
            sample.is_locked = 1;
            order = result.order;
            client = result.client;
            analysesGroups = result.analyses_groups;
            $samples.sampleIsDirty = false;
        }

        const onFailure = err => {
            if (err.code === 'not_found') {
                notFound = true;
            }
        };

        R.handle(R.sample.details, sampleId, onSuccess, onFailure, LOADER.PAGE);
    }


    const save = () => {

        const onSuccess = result => {
            sample = result;
            sample.is_collapsed = 0;
            $samples.changed = true;
            $samples.sampleIsDirty = false;
            Notifier.showMessage("Το δείγμα ενημερώθηκε");
        }

        const onFailure = err => {
            if (err.code && err.code === 'same_object_identifier') {
                Alert.warning("Ενημέρωση δείγματος", `Υπάρχει ήδη καταχωρημένο δείγμα με τον κωδικό "${err.params.code}"`, () => setFocusTo(`sampleCode-${sample.id}`));
            }
        };

        R.handle(R.sample.edit, sample, onSuccess, onFailure, LOADER.POPUP);
    }

    const onChange = () => {
        $samples.sampleIsDirty = true;
    }

    const onPrint = () => {
        printItems = {
            object: 'samples',
            samples: [sample.id]
        };
    }

    const closePrint = () => {
        printItems = null;
    }

    onDestroy(() => {
        $samples.sampleIsDirty = false;
        removeEventListener("beforeunload", beforeUnloadListener, {capture: true});
    });

    const setPageHeaderControls = () => {
        pageHeaderControls.map(item => {
            if (item.id === 'save') {
                item.active = $samples.sampleIsDirty;
            }
        });
        pageHeaderControls = pageHeaderControls;
    }

    load();

    $: {
        if (sample) {
            // handle browser refresh or close events
            if ($samples.sampleIsDirty && !unloadEventInitialized) {
                addEventListener("beforeunload", beforeUnloadListener, {capture: true});
                unloadEventInitialized = true;
                setPageHeaderControls();
            } else if (!$samples.sampleIsDirty && unloadEventInitialized) {
                removeEventListener("beforeunload", beforeUnloadListener, {capture: true});
                unloadEventInitialized = false;
                setPageHeaderControls();
            }
        }
    }
</script>

<Breadcrumb {breadcrumb}/>
{#if sample}
    <PageHeader title="Δείγμα { sample.code }" subtitle="Εντολή { order.code }, { client ? client.company : '' }" controls={ pageHeaderControls }
                sticky on:save={ save }/>
    <OrderSample bind:sample={ sample } {analysesGroups} allowOnCloud="{ client.cloud_key != null }" singleEdit
                 on:change={ onChange }
                 on:print={ onPrint }/>
{/if}

{#if notFound}
    <PageNotFound message="Το δείγμα που ζητήσατε δεν βρέθηκε!"/>
{/if}

{#if printItems}
    <PdfModal {printItems} closeCallback="{ closePrint }"/>
{/if}